(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module", "exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.esMX = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "rich": {
      "validator": {
        "type": {
          "array": "El tipo de datos debe ser una matriz",
          "url": "Ingresa una URL válida",
          "date": "Ingresa una fecha válida",
          "email": "Ingresa un correo electrónico válido",
          "string": "Ingresa caracteres",
          "tel": "Ingresa un número de teléfono válido",
          "number": "Ingresa números"
        },
        "max": {
          "tel": "No se pueden superar los {{config}} caracteres",
          "number": "No puede ser más que {{config}}",
          "email": "No se pueden superar los {{config}} caracteres",
          "url": "No se pueden superar los {{config}} caracteres",
          "date": "Selecciona una fecha anterior a {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "array": "Selecciona hasta {{config}} productos",
          "string": "No se pueden superar los {{config}} caracteres"
        },
        "min": {
          "string": "Debes ingresar al menos {{config}} caracteres",
          "array": "Selecciona un mínimo de {{config}} productos",
          "email": "Debes ingresar al menos {{config}} caracteres",
          "tel": "Debes ingresar al menos {{config}} caracteres",
          "number": "No puede ser menos que {{config}}",
          "date": "Selecciona una fecha posterior a {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "url": "Debes ingresar al menos {{config}} caracteres"
        },
        "len": {
          "string": "Ingresa {{config}} caracteres",
          "number": "La longitud debe ser igual a {{config}}",
          "array": "Selecciona {{config}} productos",
          "tel": "Ingresa {{config}} caracteres",
          "date": "Selecciona una fecha anterior a {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "email": "Ingresa {{config}} caracteres",
          "url": "Ingresa {{config}} caracteres"
        },
        "notWhitespace": "Contenido en blanco no válido",
        "custom": "Error de verificación",
        "pattern": "Error de formato",
        "required": "Esto es necesario"
      },
      "timePicker": {
        "minutes": "",
        "hours": "",
        "today": "Hoy",
        "formatDate": "DD/MM",
        "selectTime": "Selecciona",
        "now": "Ahora"
      },
      "textArea": {
        "placeholder": "Especifica..."
      },
      "resultPage": {
        "networkSubtext": "Haz clic para volver a cargar",
        "emptyText": "No hay datos disponibles",
        "networkText": "Error de red",
        "lostText": "No se encontró la página que buscas"
      },
      "common": {
        "selectText": "Selecciona",
        "ok": "Aceptar",
        "cancel": "Cancelar",
        "confirm": "Aceptar"
      },
      "segmentPicker": {
        "next": "Siguiente",
        "prev": "Volver"
      }
    }
  };
  module.exports = exports["default"];
});